const toNumber = (value, fallback = 0) => {
  const number = Number(value)
  return Number.isFinite(number) ? number : fallback
}

const toMoney = (value) => Math.round(toNumber(value) * 100) / 100

const isSelected = (item = {}) => item.status === true || item.status === 1 || item.status === '1'

const getDiscountedLineTotal = (item = {}) => {
  const directTotal = toNumber(item.discountedTotalPrice, Number.NaN)
  if (Number.isFinite(directTotal)) return toMoney(directTotal)

  const count = Math.max(toNumber(item.count), 0)
  const discountedPrice = toNumber(item.discountedPrice, Number.NaN)
  if (Number.isFinite(discountedPrice)) return toMoney(discountedPrice * count)

  const price = toNumber(item.price)
  const discount = toNumber(item.discount, 10)
  const rate = discount > 0 ? discount / 10 : 1
  return toMoney(toMoney(price * rate) * count)
}

export function calculateSelectedDiscountTotal(items = []) {
  if (!Array.isArray(items)) return 0

  const totalCents = items
    .filter(isSelected)
    .reduce((sum, item) => sum + Math.round(getDiscountedLineTotal(item) * 100), 0)

  return totalCents / 100
}

export function formatCartMoney(value) {
  return toMoney(value).toFixed(2)
}
